import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/Dashboard';
import { DevicesPage } from './pages/Devices';
import { RoutinesPage } from './pages/Routines';
import { EventsPage } from './pages/Events';
import { MeasurementPage } from './pages/Measurement';
import { PresencePage } from './pages/Presence';
import { SettingsPage } from './pages/Settings';

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="radiateurs" element={<DevicesPage />} />
        <Route path="radiateurs/:deviceId" element={<DevicesPage />} />
        <Route path="routines" element={<RoutinesPage />} />
        <Route path="routines/:routineId" element={<RoutinesPage />} />
        <Route path="evenements" element={<EventsPage />} />
        <Route path="mesure" element={<MeasurementPage />} />
        <Route path="presence" element={<PresencePage />} />
        <Route path="reglages" element={<SettingsPage />} />
        <Route path="*" element={<p className="empty">Page introuvable.</p>} />
      </Route>
    </Routes>
  );
}
